import React from 'react';
import { useMediaQuery } from '@mui/material';
import CallMadeIcon from '@mui/icons-material/CallMade';
import CallReceivedIcon from '@mui/icons-material/CallReceived';

const DirectionIndicator = ({ direction }) => {
    const isMobile = useMediaQuery("(max-width: 600px)");
    if (direction === 'outbound') {
        return <CallMadeIcon sx={{ color: '#4caf50', mt: "-3px", fontSize: isMobile ? "1.0rem" : "1.5rem" }
        } />;
    }
    return <CallReceivedIcon sx={{ color: '#ff9800', fontSize: isMobile ? "1.0rem" : "1.5rem" }} />;
};

export default DirectionIndicator;
